import { AdminLayout } from './AdminLayout'
import { withAdminLayout } from './withAdminLayout'

const ConnectedAdminLayout = withAdminLayout(AdminLayout)

export { ConnectedAdminLayout as AdminLayout }
